import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import { Link } from 'react-router-dom';

function ApplyToday({}) {
  return (
    <Layout>
      <SEO title='ApplyToday' />
      <div className='placeholder-block'>
        <h1>Hero - Apply Today</h1>
        <a href='/applynow' target='_blank' rel='nofollow noreferrer'>
          Start your application
        </a>
      </div>
      <div className='placeholder-block'>
        <h2>Content Left - Direct Lending by Vanderbilt</h2>
        <a href='/applynow' target='_blank' rel='nofollow noreferrer'>
          Learn More
        </a>
      </div>
      <div className='placeholder-block'>
        <h2>Three Up Module</h2>
        <h3>Home UpGrade Loan</h3>
        <Link to='/mortgages-and-loans/home-upgrade-loan/'>Get A Quote</Link>
        <h3>eScore</h3>
        <Link to='/mortgages-and-loans/home-upgrade-loan/'>eScore</Link>
        <h3>Commercial Lending</h3>
        <Link to='/mortgages-and-loans/commercial-lending/'>Get A Quote</Link>
      </div>
      <div className='placeholder-block'>
        <h2>Video Module - Application Process</h2>
      </div>
      <div className='placeholder-block'>
        <h2>CTA Module - Ready to Apply</h2>
        <a href='/applynow' target='_blank' rel='nofollow noreferrer'>
          Apply Today
        </a>
      </div>
    </Layout>
  );
}

ApplyToday.getInitialProps = async ({}) => {
  try {
    // Fetch server-rendered data here
    return { data: {} };
  } catch (error) {
    // Handle issues loading data
    if (error.response.status === 404) return { statusCode: 404 };
    return { error };
  }
};

ApplyToday.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default ApplyToday;
